import React from "react";
import Button from "./Button";

const OutlinedButton = (props) => <Button border="solid" borderWidth={1} borderColor="#A3A9B1" bg="transparent" bgHovered="lightestShade" color="darkestShade" {...props} />;

export default OutlinedButton;
